import { createAxiosInstance } from '@speechki-frontend/shared/axios';
import { keyBy } from '@speechki-frontend/shared/helpers/functions';

const URL = process.env.VUE_APP_BASE_URL;

const axios = createAxiosInstance(URL, { enableGuestAccess: true, rejectOn5xx: true });

const EXCLUDED_TAGS = ['p', 's'];

export const fetchSsmlTags = async (query = {}) => {
    const params = {
        page_size: 100,
        version: 2,
        ...query
    };

    const { results = [] } = await axios.get('/api/v1/ssml_tags/', { params });

    const tags = keyBy(
        results.filter(tag => !EXCLUDED_TAGS.includes(tag.name)),

        'name',

        tag => {
            tag.attribute.forEach(attr => {
                if (attr.optional) {
                    Object.keys(attr.optional).forEach(key => {
                        attr.optional[key] = keyBy(attr.optional[key], 'name');
                    });
                }
            });

            tag.attribute = keyBy(tag.attribute, 'name');
        }
    );

    return tags;
};

export const fetchSsmlTagsBySpeaker = (speaker, extraParams = {}) => {
    return fetchSsmlTags({ speaker_slug: speaker, ...extraParams });
};
